"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnresolvedDockerfileVariableHandling = exports.HashAlgorithm = exports.OsReleaseFilePath = exports.ImageType = void 0;
var ImageType;
(function (ImageType) {
    ImageType[ImageType["UnspecifiedArchiveType"] = 0] = "UnspecifiedArchiveType";
    ImageType[ImageType["Identifier"] = 1] = "Identifier";
    ImageType["DockerArchive"] = "docker-archive";
    ImageType["OciArchive"] = "oci-archive";
    ImageType["KanikoArchive"] = "kaniko-archive";
})(ImageType || (exports.ImageType = ImageType = {}));
var OsReleaseFilePath;
(function (OsReleaseFilePath) {
    OsReleaseFilePath["Linux"] = "/etc/os-release";
    OsReleaseFilePath["LinuxFallback"] = "/usr/lib/os-release";
    OsReleaseFilePath["Lsb"] = "/etc/lsb-release";
    OsReleaseFilePath["Debian"] = "/etc/debian_version";
    OsReleaseFilePath["Alpine"] = "/etc/alpine-release";
    OsReleaseFilePath["RedHat"] = "/etc/redhat-release";
    OsReleaseFilePath["Oracle"] = "/etc/oracle-release";
    OsReleaseFilePath["Centos"] = "/etc/centos-release";
})(OsReleaseFilePath || (exports.OsReleaseFilePath = OsReleaseFilePath = {}));
var HashAlgorithm;
(function (HashAlgorithm) {
    HashAlgorithm["Sha256"] = "sha256";
    HashAlgorithm["Sha1"] = "sha1";
})(HashAlgorithm || (exports.HashAlgorithm = HashAlgorithm = {}));
var UnresolvedDockerfileVariableHandling;
(function (UnresolvedDockerfileVariableHandling) {
    UnresolvedDockerfileVariableHandling["Abort"] = "Abort";
    UnresolvedDockerfileVariableHandling["Continue"] = "Continue";
})(UnresolvedDockerfileVariableHandling || (exports.UnresolvedDockerfileVariableHandling = UnresolvedDockerfileVariableHandling = {}));
//# sourceMappingURL=types.js.map